import React, {useState} from 'react';
import {Table} from '@/web-components';
import {getBaseLevelTableHeader} from '../BaseLevelTableHeader';
import CustomScrollDiv from '../../../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import {getBaseLevelTableHeaderTotals} from '../BaseLevelTableHeaderTotals';

export const BaseLevelWrapper = ({tableHeader, getRows, enabledColumns, currentLength, hasNextPage, refetch, intl}) => {
	const [modalTasksFetching, setModalTasksFetching] = useState(false);

	const fetchMore = () => {
		const refetchObject = {};
		if (hasNextPage) {
			setModalTasksFetching(true);
			refetchObject.showLoader = true;
			refetchObject.pageSize = currentLength + 30;
			refetch(refetchObject, null, () => setModalTasksFetching(false));
		} else if (modalTasksFetching) {
			setModalTasksFetching(false);
		}
	};

	const handleScroll = e => {
		if (!modalTasksFetching && e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 300) {
			fetchMore();
		}
	};

	return (
		<CustomScrollDiv className="custom-scrollbar-div" handleScroll={handleScroll}>
			<div>
				<Table>
					{getBaseLevelTableHeader(enabledColumns, tableHeader.customFieldDefinitions)}
					{getBaseLevelTableHeaderTotals(tableHeader, intl)}
					{getRows()}
				</Table>
			</div>
		</CustomScrollDiv>
	);
};
